import { render, staticRenderFns } from "./VideoQuestions.vue?vue&type=template&id=c2b0a73a&scoped=true&"
import script from "./VideoQuestions.vue?vue&type=script&lang=js&"
export * from "./VideoQuestions.vue?vue&type=script&lang=js&"
import style0 from "./VideoQuestions.vue?vue&type=style&index=0&id=c2b0a73a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b0a73a",
  null
  
)

export default component.exports